/* eslint-disable */
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Tabs } from 'antd';
import { renderTabBarProducts } from 'components/MarkupAndBaseRateStyledWrapper/MarkupAndBaseRateStyledWrapper';
import SettingTemplate from './SettingTemplate';

function SettingTab({ settings, initial }) {
  const SettingTabItems = useMemo(() => {
    return (
      Object.entries(settings || {}).map(([key, value], i) => ({
        key: `${i}`,
        label: key, // e.g. "webhook"
        children: <SettingTemplate type={key} data={value} />
      })) || []
    );
  }, [settings, initial]);

  return (
    <Tabs
      defaultActiveKey="0"
      size="large"
      items={SettingTabItems}
      type="card"
      tabBarGutter={8}
      renderTabBar={renderTabBarProducts}
      style={{ marginTop: '15px' }}
    />
  );
}

SettingTab.propTypes = {
  settings: PropTypes.arrayOf(
    PropTypes.shape({
      product_name: PropTypes.string,
      configuration: PropTypes.arrayOf(PropTypes.object)
    })
  ),
  initial: PropTypes.objectOf(PropTypes.any)
};

SettingTab.defaultProps = {
  settings: [],
  initial: {}
};

export default SettingTab;
